export const DEFAULT_HEADER_TYPE = 'persona';

export const DEFAULT_STEP = 10000;
